import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useContent } from "../context/ContentContext";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] } }),
};

export const Testimonials = () => {
  const { content } = useContent();
  const TESTIMONIALS = content.testimonials || [];
  return (
    <section id="proof" className="relative py-24 lg:py-36 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// Field Reports</span>
          <h2 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-6xl leading-[0.9]">
            They already<br />vanished
          </h2>
        </div>
        <p className="max-w-sm font-body text-white/50 leading-relaxed">
          Real reports from the resistance. Identities kept anonymous, as it should be.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {TESTIMONIALS.map((t, i) => (
          <motion.div
            key={t.handle}
            data-testid={`testimonial-${i}`}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="group bg-[#050505] p-8 lg:p-10 hover:bg-[#0d0d0d] transition-colors duration-500 flex flex-col"
          >
            <Quote className="text-accent mb-6 rotate-180" size={22} fill="currentColor" />
            <p className="font-body text-white/75 leading-relaxed flex-1">"{t.quote}"</p>
            <div className="mt-8 pt-6 border-t border-white/10 flex items-center gap-3">
              <span className="h-9 w-9 flex items-center justify-center border border-accent/40 font-mono text-[10px] text-accent">✦</span>
              <div>
                <p className="font-mono text-xs tracking-[0.15em] text-white/90">{t.handle}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">{t.role}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
